module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-115-min.5173a922.jpg";